module.exports = __webpack_public_path__ + "assets/shape-footer-bottom.9c568153.svg";